import clsx from 'clsx';
import { SidebarDivider } from './SidebarDivider';
import { SidebarElementsCube } from './SidebarElementsCube';
import { motion } from 'framer-motion';
import { FloatingOverlay } from '@floating-ui/react';
import { useElementsUIContext } from '../../../context/ElementsUIContext.context';
import { useIsSmallViewport } from '../../../hooks';

export type SidebarProps = {
  avatar?: JSX.Element | false;
  children: React.ReactNode;
};

export const Sidebar = ({ children, avatar }: SidebarProps): JSX.Element => {
  const { setIsNavigationBarOpen } = useElementsUIContext();
  const isSmall = useIsSmallViewport();

  return (
    <>
      {isSmall && (
        <FloatingOverlay
          lockScroll
          onClick={() => setIsNavigationBarOpen(false)}
          className="z-[51] bg-background-900 bg-opacity-40"
        />
      )}

      <motion.aside
        exit={{ width: 0 }}
        aria-label="Sidebar"
        initial={{ width: 0 }}
        animate={{ width: 88 }}
        className="px-0 fixed sm:sticky h-dvh min-h-dvh z-[51] top-0 bg-palette-600 border-none shadow-classic"
      >
        <div className="h-[inherit] shadow-inner gap-6 py-6 overflow-y-auto flex flex-col justify-start items-center">
          {avatar && (
            <div className={clsx('flex flex-row w-full h-[72px] justify-center items-center mb-10 py-2')}>{avatar}</div>
          )}

          {children}

          {/* Bottom group */}
          <div className={'w-full flex flex-col justify-center items-center mt-auto'}>
            <SidebarDivider className="mb-6" />
            <SidebarElementsCube className="text-palette-1000" />
          </div>
        </div>
      </motion.aside>
    </>
  );
};
